const fiveRouters = [
    // {
    //     path: '/display',
    //     name: 'Display',
    //     component: () => import('@/views/Display'),
    //     meta: {requiresAuth: false},
    // },
    {
      path: "/five",
      name: "FiveMode",
      component: () => import("@/components/LayOut/Main"),
      meta: {requiresAuth: true},
      children: [
        // {
        //   path: "test",
        //   component: () => import('@/views/five/test/Index'),
        //   meta: {requiresAuth: true},
        // },
      ]
    }
];

export  default fiveRouters;
